
import {
  connectSocket,
  disconnectSocket,
  receiveMessage,
  getNotifications,
  getDocsNotifications,
  GetAllNotificationBusinessAsync,
  GetAllNotificationCustomerAsync,
  getPreviousChatRoomId,
  getChatNotification,
  AddNewUserToChat,
  setNewlyCreatedQA,
  closeChatSession,
  RemoveUsersFromChat,
  UnBlure,
  updateMessage,
  getNotificationSuccessCustomer,
  getNotificationSuccessBusiness,
  UpdateIsReadMsg,
  updateUserInNotification,
  updateUserInNotificationForChat,
  updateUserInChat
} from "./chatSlice";


import { phoneVerification, UpdateUserForChat, updateDeletionRequestStatus, RefreshUserBusiness, RefreshUserCustomer, createUserConnectionSuccess, updateUserConnectionWithChatSuccess, updateUserLastMsg } from "./usersSlice";
import { RefreshAdmins } from "./adminManagementSlice";
// import { useDispatch } from "react-redux";
import io from "socket.io-client";
import { ApiConnection } from "../config/env";
import axiosInstance from "../helper/axiosInstance";
import { setHideShowMA } from "./adminManagementSlice";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import { renewToken, UploadingProgress } from "./authSlice";
import { toast } from "react-toastify";
import { UserBlockUnBlock } from "./staticsSlice";
import { forceLogout } from "../components/Utils/forceLogout";


class Socket {
  static async socketInit(userId, dispatch) {
    let accessToken = JSON.parse(sessionStorage.getItem("userLoggedToken"));
    if (!this.socket) {
      this.socket = io.connect(ApiConnection.BACKEND_URL, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5,
        auth: {
          token: accessToken,
        },
      });

      await new Promise((resolve) => {
        this.socket.on("connect", async (res) => {
          this.isConnected = this?.socket?.connected;
          resolve();
          console.log("socket connected----", this?.socket);
          dispatch(connectSocket(this.isConnected));

          const resp = sessionStorage.getItem("userLoggedDetails");
         const user = resp ? JSON.parse(resp) : null;

        if (!user?.userId) {
          console.error("User not available, skipping socket init");
         return;
         }

      const userId = user.userId;
          console.log("loggedin userId is here!!!!!!!!!!!", userId);
          let updated = await axiosInstance.post(
            "/BusisnessUser/updatedConnectionId",
            {
              userId: userId,
              connectionId: this.socket?.id,
            }
          );
          this.socket?.emit("joinRoom", { userId });
        });

        this.socket.on('connect_error', async error => {
          console.log('connect_error', error);
          console.log('🛑 Closing socket');
          this.socket = null;
          if (error.message === 'TOKEN_EXPIRED') {
            const refreshToken =await  JSON.parse(sessionStorage.getItem("refreshToken"));
            const accessToken =await  JSON.parse(
              sessionStorage.getItem("userLoggedToken")
            );
            console.log('Original token:WS', accessToken);
            console.log('Refresh token:WS', refreshToken);
            await dispatch(renewToken([refreshToken], accessToken));
          }
          // if (
          //   error.message === 'INVALID_TOKEN' ||
          //   error.message === 'NO_TOKEN'
          // ) {
          //   forceLogout();
          // }
          // this.handleReconnectionAttempt(reject);
        });

        this.socket.on('auth_error', data => {
          console.log(`auth_error ${data}`);
          forceLogout();
        });
        
        this.socket.on("disconnect", (res) => {
          console.log("disconnect", res);
          this.isConnected = this.socket?.connected;
        });
        this.socket.on("reconnect", (e) => {
          console.log("reconnect", this.socket, e);
          this.isConnected = this.socket?.connected;
        });

        this.socket.on("newMessage", (sendMessageData) => {
          console.log("newMessage----", sendMessageData);
       
          dispatch(updateUserLastMsg(sendMessageData?.appUser))

          if (!sendMessageData?.isMsgAutoGenrated && !sendMessageData?.isSenderAdmin) {
            dispatch(UpdateIsReadMsg(true));
            const user = JSON.parse(sessionStorage.getItem("userLoggedDetails"));
            if (!sendMessageData?.chatUser?.connectedTo) {
              console.log('play sound for all admin');
              window.dispatchEvent(new Event('playNotificationSound'));
            }else if(sendMessageData?.chatUser?.connectedTo  && sendMessageData?.chatUser?.connectedTo === user?.id){
              console.log('Play sound for only connected admin');
             window.dispatchEvent(new Event('playNotificationSound'));
          }else{
            console.log('play sound for no one');
          }
        }

          // this.socket.emit("joinChat", sendMessageData?.chatId);
          const {
            chatId,
            chatUser,
            createdAt,
            text,
            senderId,
            receiverId,
            isSenderAdmin,
          } = sendMessageData;

          const newUser = {
            ...chatUser,
            // id: chatUser.id, 
            ChatId: chatId,
            lastMessage: text,
            lastChatTime: createdAt,
            isLastMsgRead: false,
            UnReadMsgCount: 1,
            accountType: chatUser.business ? "business" : "customer",
            connectedTo: receiverId,
            isSessionExpired: false,
            isSenderAdmin: isSenderAdmin,

          };
          if (!isSenderAdmin) {
            dispatch(AddNewUserToChat(newUser));
            // Play sound only if the logged-in user is the receiver
            let resp = sessionStorage.getItem("userLoggedDetails");
            let loggedInUserId = resp ? JSON.parse(resp).userId : null;
            if (loggedInUserId && loggedInUserId === receiverId) {
              console.log('callling 2');

              window.dispatchEvent(new Event('playNotificationSound'));
            }

          }

          if (sendMessageData?.tempId && isSenderAdmin) {
            console.log('Updated', sendMessageData)
            const payload = {
              tempId: sendMessageData.tempId,
              id: sendMessageData.id,
              status: 'sent',
              ...sendMessageData
            };
            dispatch(updateMessage(payload));
          } else {
            console.log('NEW')
            let data = [];
            let newMassage = sendMessageData;
            newMassage.text = sendMessageData.text;
            if (userId === sendMessageData.senderId) {
              newMassage.user = { _id: 1 };
            } else {
              newMassage.user = { _id: 2 };
            }
            data.push(newMassage);
            if (sendMessageData?.chatUser) {
              dispatch(getChatNotification(sendMessageData));
              dispatch(UpdateUserForChat(sendMessageData));
              dispatch(receiveMessage(data));
            }
          }

        });

        // this.socket.on("chatNotify", (data) => {
        //   console.log("chatNotify----", data);
        //   dispatch(getChatNotification(data));
        //   // dispatch(AddNewUserToChat(data));
        // });
        this.socket.on("NewUserAdded", (data) => {
          console.log("NewUserAdded----", data);
          // dispatch(AddNewUserToChat(data));
        });
        // this.socket.on("handleChatNotify", (data) => {
        //   console.log("handleChatNotify----", data);
        //   dispatch(getChatNotification(data));
        //   dispatch(UpdateUserForChat(data));
        // });
        this.socket.on("getNotification", (msgNotificationData) => {
          let data = [];
          let newMassage = msgNotificationData;
          newMassage.text = msgNotificationData.text;
          if (userId === msgNotificationData.senderId) {
            newMassage.user = { _id: 1 };
          } else {
            newMassage.user = { _id: 2 };
          }
          data.push(newMassage);
          dispatch(getNotifications(data));
        });
        this.socket.on("handleDocsUpload", (docsData) => {
          console.log("handleDocsUpload in socket Connect", docsData?.businessUserTbl);
          window.dispatchEvent(new Event('playNotificationSound'));
          dispatch(getDocsNotifications(docsData));
          if (docsData?.businessUserTbl) {
            dispatch(RefreshUserBusiness(docsData?.businessUserTbl))
            // dispatch(updateDeletionRequestStatus(docsData?.businessUserTbl));
            dispatch(getNotificationSuccessBusiness(false));
          } else {
            dispatch(RefreshUserCustomer(docsData?.customerTbl));
            dispatch(getNotificationSuccessCustomer(false));
          }
        });
      });
      this.socket.on("adminAvailable", (data) => {
        console.log("previous users chat in socket ", data);
        dispatch(getPreviousChatRoomId(data));
      });
      this.socket.on("updateChatRoom", (data) => {
        console.log("updateChatRoom users chat in socket ", data);
        this.socket.emit("joinChat", data?.id);
      });
      this.socket.on("chatSessionExpired", (data) => {
        console.log("chatSessionExpired ", data);
        dispatch(closeChatSession(data));
      });
      this.socket.on("UnBlurred", (data) => {
        console.log("UnBlurred ", data);
        dispatch(UnBlure());
        const Sdata = { ...data, blur: false }
        // dispatch(updateUserInChat(Sdata));
        dispatch(updateUserConnectionWithChatSuccess(Sdata));
        dispatch(updateUserInNotificationForChat(Sdata));
      });
      this.socket.on("RemoveUserFromChat", (data) => {
        console.log("RemoveUserFromChat^^^^^^^^^^^^^^^^^^^^ ", data);
        const { connectedToAdmin, ...pruned } = data;
        dispatch(RemoveUsersFromChat(pruned));
        const Sdata = { ...data, blur: true }
        dispatch(updateUserConnectionWithChatSuccess(Sdata));
        dispatch(updateUserInNotificationForChat(Sdata));
      });
      this.socket.on("chatNotify", (data) => {
        console.log("chatNotify here ", data);
        dispatch(RemoveUsersFromChat(data));
      });
      this.socket.on("showHidePrimaryMadmin", (data) => {
        console.log("showHidePrimaryMadmin here ", data);
        dispatch(setHideShowMA(data));
      });
      this.socket.on("QuestionCreatedForTempCust", (data) => {
        console.log("QuestionCreated in socket ", data);
        dispatch(setNewlyCreatedQA(data));
      });
      this.socket.on("AdminLogin", (data) => {
        console.log("AdminLogin login in socket >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", data);
        dispatch(RefreshAdmins(data));
      });
      this.socket.on("NewPhoneNumberVerifed", (data) => {
        console.log("NewPhoneNumberVerifed in socket ((((((((((((((((((((((((((((((())))))))))))))))))))))))))))))) ", data);
        dispatch(phoneVerification(data));
      });
      this.socket.on("UploadingTracker", (data) => {
        console.log("UploadingTracker...) ", data);
        dispatch(UploadingProgress(data));
      });
      this.socket.on("ConnectedToAdmin", (data) => {
        console.log("ConnectedToAdmin...) ", data);
        dispatch(createUserConnectionSuccess(data));
        dispatch(updateUserInNotification(data));
        dispatch(updateUserInChat(data));
      });
      this.socket.on("BlockedUserProfile", (data) => {
        console.log("BlockedUserProfile...) ", data);
        dispatch(UserBlockUnBlock(data));
      });
      this.socket.on("AmountDeducted", (data) => {
        console.log("AmountDeducted...) ", data);
        dispatch(UserBlockUnBlock(data));
      });

      // Add socket event listener for deletion requests
      //   this.socket.on("deletionRequest", (data) => {
      //     console.log("Deletion request received in socket", data);
      //     dispatch(updateDeletionRequestStatus(data));

      //     // Show toast notification for deletion request
      //     const accountType = data.accountType === "business" ? "Business" : "Customer";
      //     const userName = data.userName || data.userId || "User";
      //     toast.warning(`${accountType} account "${userName}" has requested account deletion!`, {
      //       position: "top-right",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //     });
      //   });
      // });
    }
  }

  static joinRoom(roomData) {
    this.socket.emit("joinChat", roomData);
  }

  static onSend(userId, messageData, dispatch) {
    let data = [];
    let newMassage = messageData;
    newMassage.text = messageData.text;
    if (userId === messageData.senderId) {
      newMassage.user = { _id: 1 };
    } else {
      newMassage.user = { _id: 2 };
    }
    data.push(newMassage);
    dispatch(receiveMessage(data));
    this.socket?.emit("sendMessage", messageData);
    // const data = [];
    // dispatch(receiveMessage(data));
  }

  // static handleNewMessage(messageData, dispatch) {
  //   if (this.newMessageCallback) {
  //     this.newMessageCallback(messageData);
  //     if (messageData.senderId !== loggesInUser.id) {
  //       dispatch(incrementUnreadMessageCount({ userId: messageData.senderId }));
  //     }
  //   }
  // }

  static logoutUser(dispatch) {
    // this.socket.disconnect();
    this.socket = null;
    this.isConnected = false; 
    dispatch(disconnectSocket());
  }
}

export default Socket;
